import React, { useState } from "react";
import Contacts from "./Contacts";
import "./i18n";
import About from "./About";
import Body from "./Body";
import Fleet from "./Fleet";
import Navbar from "./Components/Navbar/Navbar";
import Features from "./Features";
import TouristTaxBanner from "./TouristTaxBanner";
const App = () => {
  const [quoteMessage, setQuoteMessage] = useState("");
  const [choosedCar, setChoosedCar] = useState({
    brand: null,
    code: null,
    picture: null,
  });
  const [showNavbar, setShowNavbar] = useState(false);
  return (
    <>
      <Navbar setShowNavbar={setShowNavbar} showNavbar={showNavbar} />
      <section
        id="body"
        style={{
          marginTop: showNavbar ? "200px" : "0px", // Conditional marginTop
          transition: "margin-top 0.5s ease-in-out", // Transition the margin-top property
        }}
      >
        <TouristTaxBanner />
        <Body
          choosedCar={choosedCar}
          setChoosedCar={setChoosedCar}
          showNavbar={showNavbar}
        />
      </section>
      <section id="aboutUs">
        <About />
      </section>{" "}
      <section id="features">
        <Features />
      </section>
      <section id="fleet">
        <Fleet
          setQuoteMessage={setQuoteMessage}
          setChoosedCar={setChoosedCar}
        />
      </section>
      {/* <section id="reviews">
        <Reviews />
      </section> */}
      <section id="contacts">
        <Contacts quoteMessage={quoteMessage} />
      </section>
    </>
  );
};
export default App;
